export const BASE_DATA_TYPES = {
  CUSTOMER: 'customer',
  SUPPLIER: 'supplier',
}
